<template>
    <div>

        <Spinner v-bind:title="'Getting Invoices Please Wait'|trans" v-show="loading"></Spinner>

        <div class="search-block" v-show="!loading">
            <div class="col-xs-12" v-show="isErrorMessageDisplayed">
                <div class="alert alert-danger">
                    {{'Date From Cannot Be After The Date Until'|trans}}
                </div>
            </div>
            <div class="col-xs-4 text-center" @click="openDatePickerFrom">
                <button class="btn btn-primary full-width">{{'From'|trans}} <i class="fa fa-calendar"></i> </button><br>
                <strong >{{search.dateFrom|formatDate('YYYY/MM/DD')}}</strong>
            </div>
            <div class="col-xs-4 text-center" @click="openDatePickerUntil">
                <button class="btn btn-primary full-width">{{'Until'|trans}} <i class="fa fa-calendar"></i> </button><br>
                <strong >{{search.dateUntil|formatDate('YYYY/MM/DD')}}</strong>
            </div>
            <div class="col-xs-4">
                <button class="btn btn-primary full-width" @click="getDocuments()" v-bind:disabled="!isSearchBoutonEnabled">{{'Search'|trans}}</button>
            </div>
            <div class="col-xs-12">
                <DatePicker
                        v-model="search.dateFrom"
                        input-class="hidden"
                        ref="datePickerFrom"
                ></DatePicker>

                <DatePicker
                        v-model="search.dateUntil"
                        input-class="hidden"
                        ref="datePickerUntil"
                ></DatePicker>
            </div>
            <div class="col-xs-12 text-center">
                <RouterLink to="download_pdf_list" class="a-href-default">
                    <span class="title">{{ 'List of quarterly invoices' | trans }}</span>
                </RouterLink>
            </div>
        </div>
        <div class="document" v-for="invoice in invoices" v-show="!loading">
            <div class="document-header row" @click="invoice.isOpen=!invoice.isOpen">
                <div class="col-xs-2 no-margin-bottom">
                    <strong class="day">{{ invoice.document_date|formatDate('DD') }}</strong><br>
                    <strong class="month">{{ invoice.document_date|formatDate('MMM') }}</strong>
                </div>
                <div class="col-xs-10 text-right no-margin-bottom">
                    <strong>#{{ invoice.document_number }}</strong><br>
                    <span v-if="invoice.customer_address !== null"><strong>{{ invoice.customer_address.number}}, {{ invoice.customer_address.street}}, {{ invoice.customer_address.zip_code}}</strong></span><br>
                    <strong>{{ invoice.job.customer.lastname }}</strong>
                </div>
            </div>
            <div class="document-body" v-show="invoice.isOpen">
                <a target="_blank" v-bind:href="getInvoicePath(invoice.id)" class="btn btn-primary full-width">{{'Download Invoice'|trans}}</a><br>
                <strong>{{'Job Reference'|trans}} : </strong> #{{ invoice.job.id }}<br>
                <strong>{{'Communication'|trans}}:</strong><br>
                        {{ invoice.communication }}<br>
                <strong>{{'Job Description'|trans}}</strong> <br>
                {{ invoice.job.job_description }}
            </div>
        </div>
    </div>
</template>

<script>
    import Routing from '../../backend-router';
    import DatePicker from 'vuejs-datepicker';
    import Spinner from '../Spinner';
    import moment from 'moment-timezone';

    export default {
        props: {},
        data() {
            return {
                invoices : null,
                loading : false,
                search : {
                    documentType:'invoice',
                    dateFrom  : null,
                    dateUntil : null
                }
            }
        },
        created() {
            this.getDocuments();
        },
        methods: {
            async getDocuments() {
                this.loading = true;
                const response = await this.$api.documents.getDocumentsOfWorkerByDateRangeAndType(this.search);
                this.invoices = response.documents.map((invoice)=>{
                    invoice.isOpen = false;
                    return invoice;
                });
                this.loading = false;
            },
            getInvoicePath(documentId){
                return  process.env.VUE_APP_API_BASE_URL + Routing.generate('worker_interface_generate_pdf', {id: documentId, action : 'generate','with_voucher':true});
            },
            openDatePickerUntil() {
                this.$refs.datePickerUntil.showCalendar();
                this.$refs.datePickerFrom.close();
            },
            openDatePickerFrom() {
                this.$refs.datePickerFrom.showCalendar();
                this.$refs.datePickerUntil.close();
            },
        },filters: {
            formatDate(value, format) {
                if (value) {
                    if (format === undefined) {
                        format = 'YYYY-MM-DD HH:mm';
                    }
                    return moment(String(value)).format(format)
                }
            }
        },
        computed : {
            isDateRangeSelected(){
                return this.search.dateFrom !== null && this.search.dateUntil !== null
            },
            isDateRangeValid(){
                return (moment(this.search.dateUntil).diff(moment(this.search.dateFrom)) >= 0);
            },
            isSearchBoutonEnabled(){
                return this.isDateRangeSelected && this.isDateRangeValid
            },
            isErrorMessageDisplayed(){
                return this.isDateRangeSelected && !this.isDateRangeValid
            }
        },
        components:{
            Spinner,
            DatePicker
        }

    }
</script>

<style scoped>
    .document{
        background-color: white;
        border: 1px solid #e4e4e4;
        margin-bottom: 15px;
    }

    .document-header{
        padding:8px;
    }

    .document-body{
        padding:8px;
        background:#efecec;
    }

    .day{
        font-size:23px;
        color: #cdcdcd;
    }
    .month{
        color: #cdcdcd;
        text-transform: capitalize;
    }

    .search-block{
        background: #dceaea;
        display: inline-block;
        width: 100%;
        padding: 8px 2px;
        position: relative;
    }

    .a-href-default{
        color:blue;
        text-decoration: underline;
    }

</style>

